import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-service',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.scss'],
})
export class ServiceComponent implements OnInit {
  constructor(
    private meta: Meta,
    private title: Title,
    private translate: TranslateService
  ) {}
  public arrayPath: string[] = [];

  ngOnInit(): void {
    this.arrayPath = window.location.href.split('/');
    if (this.arrayPath[3] === 'jp' || this.arrayPath[4] === 'jp') {
      this.meta.addTag({
        name: 'description',
        content: '',
      });
      this.title.setTitle('日本医薬品 | サービス');
      this.translate.use('jp');
      this.translate.setDefaultLang('jp');
    } else {
      this.meta.addTag({
        name: 'description',
        content:
          'Our Services | Looking towards the future, we pledge our efforts to creating a society where better medical care can be provided to patients in need.',
      });
      this.title.setTitle('JAPAN PHARMA INC. | service');
      this.translate.use('en');
      this.translate.setDefaultLang('en');
    }
  }
}
